export default __webpack_public_path__ + "static/media/gallery_01.d89d9392.jpg";